import APIClient from '@/shared/http/clients/api'

const resourceName = 'Estado'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Get = (id, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/${id}`, config)

const StateRepository = {
  GetAll,
  Get,
  Create,
  Update
}

export default StateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/state.js